import { defineStore } from 'pinia'
import SecuritySettingsStore, {
  SecuritySettingsState,
} from '@/modules/securitySettings/types/store/SecuritySettingsStore'

export const useSecuritySettingsStore: SecuritySettingsStore = defineStore('securitySettings', {
  state: () =>
    ({
      secretKey: '',
      twoFAUrl: '',
      backupCode: '',
      message: '',
    }) as SecuritySettingsState,
  getters: {
    getSecretKey: (state: SecuritySettingsState) => state.secretKey,
    getTwoFAUrl: (state: SecuritySettingsState) => state.twoFAUrl,
    getBackupCode: (state: SecuritySettingsState) => state.backupCode,
    getMessage: (state: SecuritySettingsState) => state.message,
  },
  actions: {
    async initTwoFA(data) {
      const response = await this.$services.securitySettings.initTwoFA(data)
      this.secretKey = response.secretKey
      this.twoFAUrl = response.uri
    },
    async enableTwoFA(data) {
      const response = await this.$services.securitySettings.enableTwoFA(data)
      this.backupCode = response.backupCode
    },
    async disableTwoFA(data) {
      const response = await this.$services.securitySettings.disableTwoFA(data)
      this.message = response.message
    },
    async resentVerificationEmail() {
      await this.$services.securitySettings.resentVerificationEmail()
    },
    async checkVerificationEmail(token) {
      await this.$services.securitySettings.checkVerificationEmail(token)
    },
  },
})
